module.exports = __webpack_public_path__ + "static/media/user.f08706cd.svg";